import ElVisuallyHidden from './src/visual-hidden2.mjs';
export { default as ElVisuallyHidden, default } from './src/visual-hidden2.mjs';
export { visualHiddenProps } from './src/visual-hidden.mjs';
//# sourceMappingURL=index.mjs.map
